import React, { useEffect } from 'react'
import { Container, Row, Col, Breadcrumb } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faUserShield } from '@fortawesome/free-solid-svg-icons'

import AdminTable from './partials/AdminTable'

export default function AdminsPage() {
  useEffect(() => {
    document.title = 'Quản lí nhân viên (Admin)'
  }, [])

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: 'breadcrumb-dark breadcrumb-transparent' }}>
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Quản lí thiết bị và nhân viên</Breadcrumb.Item>
            <Breadcrumb.Item active>Nhân viên (Admin)</Breadcrumb.Item>
          </Breadcrumb>
          <h4>
            <FontAwesomeIcon icon={faUserShield} className="me-2" />
            Quản lí nhân viên (Admin)
          </h4>
          <p className="mb-0">Quản lý tài khoản đăng nhập admin và permission</p>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col>
            <AdminTable />
          </Col>
        </Row>
      </Container>
    </>
  )
}

